<div class="modal modal--small" [ngClass]="{ 'modal--fade-out': isClosing }">
  <div class="modal__screen" (click)="dismiss()"></div>
  <div class="modal__content">
    <div class="modal__header">
      <div class="modal__title">{{ options?.title }}</div>
      <div class="modal__close" (click)="cancel()">
        <svg class="icon modal__close-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M232 344V280H168C154.7 280 144 269.3 144 256C144 242.7 154.7 232 168 232H232V168C232 154.7 242.7 144 256 144C269.3 144 280 154.7 280 168V232H344C357.3 232 368 242.7 368 256C368 269.3 357.3 280 344 280H280V344C280 357.3 269.3 368 256 368C242.7 368 232 357.3 232 344zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z" /></svg>
      </div>
    </div>
    <div class="modal__body">
      <p>{{ options?.body }}</p>
    </div>
    <div class="modal__footer">
      @if (!options?.hideCancelButton) {
      <button class="button button--close" type="button" (click)="cancel()">Cancel</button>
      }
      <button class="button button--delete" type="button" (click)="complete()">Delete</button>
    </div>
  </div>
</div>
